// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","532":"styles","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"5c97eead7a3de7ee5c9b","532":"bedd0f87e5d7ef64690b","691":"86cab811dbc859fa218e"}[chunkId] + ".js";
};